export const module = {
  info: {
    name: 'voip-lcr-report',
    caption: 'voip-lcr-report'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  /*sideMenu: {
    topSeparator: false,
    caption: 'LCR Report',
    icon: 'el-icon-s-grid',
    routeName: 'module->voip-lcr-report->lcr->report->list->page',
    routeParams: { listPage: 1},
  }*/
}

export default module
